// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5229": "435c2157","5336": "5083bc52","8990": "7d69c8cd",}[chunkId] + ".css"
}